



























import Vue from "vue";
import iwInputPrice from "@/encoding/components/buildingBlocks/InputPrice.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        iwInputPrice: iwInputPrice,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            pathInStore: "property.monthlyCosts",
            inputName: "monthly-charges",
            specificId: uuidv4() as string,
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return (["HOUSE", "OFFICE", "INDUSTRY","COMMERCIAL", "APARTMENT","GARAGE","OTHER","HOMES_TO_BUILD"].indexOf(this.getPropertyType()) !== - 1);
        },
        monthlyCosts: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
        transactionType: function(): string {
            return this.$store.getters["FormModule/getValue"]("transaction.type");
        },
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(monthlyCosts: number): void {
            if (monthlyCosts === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": monthlyCosts});
            }
        },
        isOptional: function(){
            return this.transactionType === "FOR_RENT";
        },
    }
});
